const TENANT_ID = 'tenantId';
const JWT_STORAGE_KEY = 'jwt_access_token';

export const getAccessTokenLS = () => localStorage.getItem(JWT_STORAGE_KEY) ?? '';
export const setAccessTokenLS = (token: string) => localStorage.setItem(JWT_STORAGE_KEY, token);
export const removeAccessTokenLS = () => localStorage.removeItem(JWT_STORAGE_KEY);

export const getTenantIdLS = () => localStorage.getItem(TENANT_ID) ?? '';
export const setTenantIdLS = (token: string) => localStorage.setItem(TENANT_ID, token);
export const removeTenantIdLS = () => localStorage.removeItem(TENANT_ID);
